var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreparingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: "auto",
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 50",
    style: {
      enableBackground: "new 0 0 35 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5E5D5C;}\r\n\t.st1{fill:#468DCC;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#273149;}\r\n\t.st4{fill:#D81A1A;}\r\n\t.st5{fill:none;stroke:#D81A1A;stroke-width:0.8414;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#273149;stroke-width:0.4329;stroke-miterlimit:10;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#005081;}\r\n\t.st9{fill:#EE812B;}\r\n\t.st10{fill:#005081;}\r\n\t.st11{fill:none;stroke:#005081;stroke-width:1.7881;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#273149;stroke-width:0.2534;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#273149;stroke-width:0.3184;stroke-miterlimit:10;}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000025415805332119952680000016762876064192695175_);}\r\n\t.st15{fill:#898989;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.78,
    y: 2.63,
    className: "st11",
    width: 29.44,
    height: 4.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.78,
    y: 42.63,
    className: "st11",
    width: 29.44,
    height: 4.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M28.88,10.65c0,6.28-5.73,12.33-11.38,14.35c-5.65-2.02-11.38-8.07-11.38-14.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M28.88,39.35c0-6.28-5.73-12.33-11.38-14.35c-5.65,2.02-11.38,8.07-11.38,14.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "7.72,33.56 17.5,31.15 27.28,33.56  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparingImage);
export default __webpack_public_path__ + "static/media/preparing_image.347b8217ec9f159815ee1e69aa579a0c.svg";
export { ForwardRef as ReactComponent };